import { render } from "./ClienteForm-Component.vue?vue&type=template&id=21083664"
import script from "./ClienteForm-Component.vue?vue&type=script&lang=js"
export * from "./ClienteForm-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__